import {useSuspenseQuery} from '@tanstack/react-query';
import {
  injectAlphabeticalSort,
  prepareSearchParams,
  severityScaleSchema,
} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {severityScaleKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getSeverityScales = async (params: QueryParams = {}) => {
  const res = await api.get(`severityscales`, {
    searchParams: prepareSearchParams(injectAlphabeticalSort(params)),
  });
  const data = await res.json();
  const pagination = extractPagination(res);

  return [severityScaleSchema.array().parse(data), pagination] as const;
};

export const useSeverityScales = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: severityScaleKeys.list(params),
    queryFn: () => getSeverityScales(params),
  });
};
export const useSeverityScalesLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getSeverityScales;
type QueryParams = Parameters<typeof severityScaleKeys.list>[0];
